import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root'
})
export class AcademicYearService {

    constructor(private http: CustomHttpService) { }

    getAllAcademicYearsWithCount(params: any): Observable<any> {
        return this.http.post(environment.getAllAcademicYearsWithCount, params);
    }

    createAcademicYear(data: any): Observable<any> {
        return this.http.post(environment.createAcademicYear, data);
    }

    updateAcademicYear(data: any): Observable<any> {
        return this.http.post(environment.updateAcademicYear, data);
    }

    deleteAcademicYear(data: any): Observable<any> {
        return this.http.post(environment.deleteAcademicYear, data);
    }

    getAllAcademicYears(params: any): Observable<any> {
        return this.http.post(environment.getAllAcademicYears, params);
    }


}

